import React, { useState } from "react";
import axios from "axios";
import { Checkbox, Col, Form, Row, message } from "antd";
import "./setting_overtime_work_allocation.css";

const SettingOvertimeWorkAllocation: React.FC = () => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    const handleSaveSetting = async (checkedValues: string[]) => {
        setLoading(true);
        try {
            const valueToSend = checkedValues.includes("1") ? "1" : "0";
            await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/setting-overtime-work-allocation/save`, {
                list_check: valueToSend
            });
            message.success("Pengaturan overtime berhasil disimpan");
        } catch (error) {
            message.error("Gagal menyimpan pengaturan");
        } finally {
            setLoading(false);
        }
    };

    const transformStyle = {
        transform: "scale(0.80)",
        transformOrigin: "top left",
        width: "125%",
    };

    return (

        <div id="i2i1" style={transformStyle}>
            <Form form={form} layout="vertical">
                <div className="gjs-grid-row" id="i8u5">
                    <div className="gjs-grid-column" id="i5ur">
                        <Form.Item label="Overtime Setting" name="list_check" style={{ marginBottom: "5px" }}>
                            <Checkbox.Group style={{ width: "100%" }} onChange={handleSaveSetting} >
                                <Row>
                                    <Col span={8}>
                                        <Checkbox value="1">Overtime</Checkbox>
                                    </Col>
                                </Row>
                            </Checkbox.Group>
                        </Form.Item>
                    </div>
                </div>
            </Form>
        </div>
    );
};

export default SettingOvertimeWorkAllocation;
